import { fetchApi } from "@/services/api"
import { mockSmithersClientService } from "@/mocks/smithers-client-service"
import type { CreateSmithersClientRequest, SmithersClientConfig } from "@/types/smithers-client"

const endpoint = "/api/v1/config/smithers/clients"
const realSmithersClientService = {
  async delete(id: number): Promise<void> {
    return fetchApi<void>(`${endpoint}/${id}`, { method: "DELETE" })
  },
  async getAll(): Promise<SmithersClientConfig[]> {
    return fetchApi<SmithersClientConfig[]>(endpoint)
  },
  async getById(id: number): Promise<SmithersClientConfig> {
    return fetchApi<SmithersClientConfig>(`${endpoint}/${id}`)
  },
  async create(data: CreateSmithersClientRequest): Promise<SmithersClientConfig> {
    return fetchApi<SmithersClientConfig>(endpoint, {
      method: "POST",
      body: JSON.stringify({ clientId: data.clientId.trim() }),
    })
  },
}

export const smithersClientService = import.meta.env.VITE_USE_MOCKS === "true"
  ? mockSmithersClientService
  : realSmithersClientService
